import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { parseJwt } from "../../../utilities/helpers";
import { Form, notification } from "antd";
import { connect, useDispatch } from "react-redux";
import API from "../../../api/api";
import { languageLable } from "utilities/helpers";
var api;
class RegisterVarifyExisting extends Component {
  constructor(props) {
    super(props);
    api = new API();
      this.state = { loading: false };
  }

  static getDerivedStateFromProps(props) {
    if (props.isLoggedIn === true) {
        if (props.isVerified === true) {
            props.history.push("/");
        } else {
            props.history.push("/account/register-verify-btn");
        }
    }
    return false;
  }

  handleFeatureWillUpdate(e) {
    e.preventDefault();
    notification.open({
      message: "Opp! Something went wrong.",
      description: "This feature has been updated later!",
      duration: 500,
    });
  }

  handleLoginSubmit = (values) => {
    const { selectedLanguageData } = this.props.app;
     
      if (this.props.auth.registerRequestData) {
          this.setState({ loading: true });
        let payload = localStorage.getItem("newEmailVr") ? {
          isdCode: this.props.auth.registerRequestData.isdCode,
          mobile: this.props.auth.registerRequestData.mobile,
          email: this.props.auth.registerRequestData.email,
          mobileCode: values.mobilecode,
          emailCode: values.emailcode,
          emailNew: localStorage.getItem("newEmailVr"),
          mobileNew: localStorage.getItem("newmobileVr"),
            IsdCodeNew: String(localStorage.getItem("newisdCodeVr") || ""),
        } : {
                isdCode: String(this.props.auth.registerRequestData.isdCode || "91"),
            mobile: this.props.auth.registerRequestData.mobile,
            email: this.props.auth.registerRequestData.email,
            mobileCode: values.mobilecode,
            emailCode: values.emailcode
        };

        api
            .post(localStorage.getItem("validateapiroute"), {
          data: payload,
        })
        .then((response) => {
            if (response.StatusCode === 200 && response.Result) {
                console.log("response: ", response);
                console.log("response Result: ", response.Result);
            // Remove register details
            localStorage.setItem("isLoggedIn", true);
                localStorage.setItem("isVerified", true);        
                this.props.history.push("/");
                window.location.reload();
            } else {
                this.setState({ loading: false });

            notification.info({
              message: "info",
              description: languageLable(selectedLanguageData, response.StatusMessage),
            });
          }
        });
    } else {
    }
  };

  onFinishFailed = (errorInfo) => {
    console.error("Failed:", errorInfo);
  };

  render() {
    const { selectedLanguageData } = this.props.app;

    return (
      <div className="ps-my-account">
        <div className="container">
          <Form
            className="ps-form--account"
            onFinish={(values) => this.handleLoginSubmit(values)}
            onFinishFailed={() => this.onFinishFailed()}
          >
            <ul className="ps-tab-list">
              <li className="active">
                <Link to="/account/login">
                  {languageLable(selectedLanguageData, "Verify OTP")}
                </Link>
              </li>
            </ul>
            <div className="ps-tab active" id="sign-in">
              <div className="ps-form__content">
                <h5>
                  {languageLable(
                    selectedLanguageData,
                    "Enter six digit verification code sent on Email id"
                                ) + " " + this.props.auth.registerRequestData.email }
                </h5>
                <div className="form-group">
                  <div className="form-group">
                    <Form.Item
                      name="emailcode"
                      rules={[
                        {
                          required: true,
                          message: languageLable(
                            selectedLanguageData,
                            "Please enter email otp code."
                          ),
                        },
                      ]}
                    >
                      <input
                                            id="emailcode"
                        className="form-control"
                                            name="emailcode"
                        type="text"
                        placeholder={languageLable(selectedLanguageData, "OTP")}
                      ></input>
                    </Form.Item>
                  </div>
                            </div>

                            <h5>
                                {languageLable(
                                    selectedLanguageData,
                                    "Enter six digit verification code sent on Mobile"
                                ) + " " + this.props.auth.registerRequestData.isdCode + " " + this.props.auth.registerRequestData.mobile }
                            </h5>
                            <div className="form-group">
                                <div className="form-group">
                                    <Form.Item
                                        name="mobilecode"
                                        rules={[
                                            {
                                                required: true,
                                                message: languageLable(
                                                    selectedLanguageData,
                                                    "Please enter mobile otp code."
                                                ),
                                            },
                                        ]}
                                    >
                                        <input
                                            id="mobilecode"
                                            className="form-control"
                                            name="mobilecode"
                                            type="text"
                                            placeholder={languageLable(selectedLanguageData, "OTP")}
                                        ></input>
                                    </Form.Item>
                                </div>
                            </div>
                <div className="form-group submit">
                                <button type="submit" className="ps-btn ps-btn--fullwidth" disabled={this.state.loading}>
                                    {this.state.loading
                                        ? languageLable(selectedLanguageData, "Loading...")
                                        : languageLable(selectedLanguageData, "Verify") }
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

export default connect(mapStateToProps)(withRouter(RegisterVarifyExisting));
